<template>
  <div class="medical_history">
    <uni-popup ref="openTheHistory" type="bottom">
      <uni-card title="导入病历" :is-full="true">
        <van-tabs class="nav-tabs" v-model="activeNumber" title-active-color="#007aff">
          <van-tab v-for="(item, index) in tabsList" :key="index" :title="item.title"></van-tab>
        </van-tabs>
        <div v-if="activeNumber === 0" class="test_data">
          <div class="switch_box">
            <div>
              <span>我填写的病历</span>
              <van-switch
                v-model="inportCheckedVal"
                active-color="#0089ff"
                size="24"
                @change="importSwitch"
              />
            </div>
            <div>
              <span>当前病症信息</span>
              <van-switch
                v-model="patientCheckedVal"
                active-color="#0089ff"
                size="24"
                @change="patientSwitch"
              />
              <switch style="transform: scale(0.7)" color="#0089ff" />
            </div>
          </div>
          <div class="list-wrap" v-if="medicalListBox && medicalListBox.length > 0">
            <van-list
              v-model="loading"
              :finished="isComplate"
              finished-text="没有更多了"
              @load="getMoreList"
            >
              <div v-for="(item, index) in medicalListBox" :key="index" class="medicalList">
                <div class="medicalText">
                  <span class="grayText">科室：</span>
                  <span class="grayRight">
                    {{ item.deptName + ' ' + item.doctorName }}
                  </span>
                </div>
                <div class="medicalText">
                  <span class="grayText">主要诊断：</span>
                  <span class="grayRight mdrug">
                    {{ gearCase(item) || '--' }}
                  </span>
                </div>
                <div class="medicalText identification">
                  <span class="grayText">互联网就诊：</span>
                  <span class="grayRight">
                    {{ dayjs(item.regVisitDate).format('YYYY-MM-DD') }}
                  </span>
                  <div class="identificationHistory" @click="prescriptionHistory(item)">
                    <img src="@funcPuzzle/mini_doctor/add.png" class="case_img" />
                    <!-- toLead -->
                    <span class="case_text">导入病历</span>
                  </div>
                </div>
              </div>
            </van-list>
          </div>
          <gl-no-content v-else :title="'暂无数据'"></gl-no-content>
        </div>
        <div v-if="activeNumber === 1" class="test_data">
          <div class="switch_box">
            <div>
              <span>我填写的病历</span>
              <van-switch
                v-model="inportSwitchVal"
                active-color="#0089ff"
                size="24"
                @change="importSwitchTwo"
              />
            </div>
          </div>
          <div class="list-wrap" v-if="inquiry && inquiry.length > 0">
            <van-list
              v-model="loading"
              :finished="isComplate"
              finished-text="没有更多了"
              @load="getMoreListTwo"
            >
              <div v-for="(item, index) in inquiry" :key="index" class="medicalList">
                <div class="medicalText">
                  <span class="grayText">科室：</span>
                  <span class="grayRight">
                    {{ item.deptName + ' ' + item.doctorName }}
                  </span>
                </div>
                <div class="medicalText">
                  <span class="grayText">主要诊断：</span>
                  <span class="grayRight mdrug">
                    {{ gearCase(item) || '--' }}
                  </span>
                </div>
                <div class="medicalText identification">
                  <span class="grayText">互联网就诊：</span>
                  <span class="grayRight">
                    {{ item.regVisitDate ? dayjs(item.regVisitDate).format('YYYY-MM-DD') : '--' }}
                  </span>
                  <div class="identificationHistory" @click="prescriptionHistory(item)">
                    <img src="@funcPuzzle/mini_doctor/add.png" class="case_img" />
                    <!-- toLead -->
                    <span class="case_text">导入病历</span>
                  </div>
                </div>
              </div>
            </van-list>
          </div>
          <gl-no-content v-else :title="'暂无记录'"></gl-no-content>
        </div>
        <div v-if="[2, 3].includes(activeNumber)" class="content">
          <div
            class="list-wrap"
            v-if="tabsList[activeNumber].list && tabsList[activeNumber].list[0]"
          >
            <van-list
              v-model="loading"
              :finished="isComplate"
              finished-text="没有更多了"
              @load="getMoreTemplateList"
            >
              <div v-for="(item, i) in tabsList[activeNumber].list" :key="i" class="item">
                <div class="title row">
                  <span>{{ item.templateName }}</span>
                </div>
                <div class="row">
                  <span class="subhead">诊断：</span>
                  <span class="text mdrug">
                    <!-- {{ sysList(item.symptomName) }} -->
                  </span>
                </div>
                <div class="row">
                  <span class="subhead">主诉：</span>
                  <span class="main">
                    {{ item.mainDiagnosis }}
                  </span>
                </div>
                <div class="last_row" @click="prescriptionHistory(item)">
                  <img class="toLead" src="@funcPuzzle/mini_doctor/toLead.png" />
                  <span class="lead_text">导入病历</span>
                </div>
              </div>
            </van-list>
          </div>
          <gl-no-content v-else :title="'暂无模板'"></gl-no-content>
        </div>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
  </div>
</template>

<script>
import { disconnectHis } from '@/views/funcPuzzle/utils/business.js'
import { getKeyValueText, getKeyValue, formatSymptomName } from '@/views/funcPuzzle/utils/util.js'
import { mapState } from 'vuex'
import {
  getVisitRecordOnlineListNew,
  getVisitRecordList,
  getRecordTemplateList
} from '@/views/funcPuzzle/utils/index.js'
// import MsTabs from '@/views/funcPuzzle/components/ms-tabs/ms-tabs.vue'
import { isTCM } from '@/views/funcPuzzle/utils/business.js'
import GlNoContent from '@/views/funcPuzzle/home/components/gl-no-content'
import dayjs from 'dayjs'
import { Toast } from 'vant'
export default {
  components: {
    GlNoContent
    // MsTabs
  },
  computed: {
    ...mapState(['doctor']),
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    },
    sysList() {
      return function (val) {
        // 诊断格式化显示
        return formatSymptomName(val)
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentDetail: {
      type: [Object, String],
      default: ''
    },
    reginfo: {
      type: [Object, String],
      default: ''
    },
    medicine: {
      type: [String, Number],
      default: ''
    },
    isManageValue: {
      type: [String, Number],
      default: ''
    },
    visitRecordType: {
      type: [String, Number],
      default: ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 如果没有配置病历模板 按照原来的tab显示
        if (false && this.isManageValue !== '1') {
          // 是否接通his
          if (disconnectHis()) {
            this.tabsList = [
              {
                title: '互联网病历'
              }
            ]
          } else {
            this.tabsList = [
              {
                title: '互联网病历'
              },
              {
                title: '咨询病历'
              }
            ]
          }
        }

        this.pages.pageNum = 1
        if (this.activeNumber === 0) {
          this.historyClick()
        }

        this.$nextTick(_ => {
          this.open()
        })
      } else {
        this.close()
      }
    },
    activeNumber: {
      handler(val, old) {
        console.log(this.activeNumber, this.visible, 'watch-----activeNumber')
        if (this.visible) {
          this.pages.pageNum = 1
          this.isComplate = false
          switch (this.activeNumber) {
            case 0:
              // 互联网
              this.historyClick()
              break
            case 1:
              // 门诊
              this.getVisitList()
              break
            case 2:
              // 私人模板
              this.getRecordTemplateLists()
              break
            case 3:
              // 公共模板
              this.getRecordTemplateLists()
              break
          }
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      loading: false,
      isComplate: false,
      listError: false,
      patientCheckedVal: false,
      inportCheckedVal: false,
      inportSwitchVal: false,
      isTCM: isTCM(),
      medicalListBox: [],
      pages: {
        pageNum: 1,
        pageSize: 10
      },
      templatePages: {
        pageNum: 1,
        pageSize: 10
      },
      broccoli: false,
      broccoliTwo: false,
      tabsList: [
        {
          title: '互联网病历'
        },
        {
          title: '咨询病历'
        },
        {
          title: '私人模板',
          list: [],
          isDone: false
        },
        {
          title: '公共模板',
          list: [],
          isDone: false
        }
      ],
      activeNumber: 0,
      isOpenPop: false,
      inquiry: [],
      showMeta: false
    }
  },
  methods: {
    dayjs,
    getKeyValueText,
    getKeyValue,
    // 获取病历模板列表
    async getRecordTemplateLists() {
      // uni.showLoading({
      //   title: '加载中'
      // })
      let type = ''
      // 如果是中医院 病历模板类型根据medicine的值来 否则走默认
      if (this.isTCM) {
        type = (this.medicine === 0 ? '2' : '1') || this.visitRecordType
      } else {
        type = this.visitRecordType
      }
      const obj = {
        hospitalID: this.hospitalID,
        templateType: Number(this.activeNumber) - 1,
        visitRecordType: type,
        state: 1,
        ...this.pages
      }
      // 私人模板和公共模板的参数不同
      const params =
        [2, 3].includes(this.activeNumber) && this.activeNumber === 2
          ? {
              ...obj,
              doctorID: this.doctor.doctorID
            }
          : obj

      const rs = await getRecordTemplateList(params)
      // uni.hideLoading()
      if (rs.code) {
        // uni.showToast({
        //   title: rs.codeDesc,
        //   icon: 'none'
        // })
        Toast.fail(rs.codeDesc)
      } else {
        // 数据是否请求完了
        // 如果是第一页 直接复制 否则拼接
        this.tabsList[this.activeNumber].list =
          this.pages.pageNum === 1
            ? rs.data
            : [...this.tabsList[this.activeNumber].list, ...rs.data]

        this.tabsList[this.activeNumber].isDone =
          this.tabsList[this.activeNumber].list.length >= rs.total
        //
        this.isComplate = this.tabsList[this.activeNumber].isDone
        this.loading = false
      }
    },
    importSwitch(e) {
      this.broccoli = e
      this.pages.pageNum = 1
      this.medicalListBox = []

      this.historyClick('importSwitch')
    },
    // 选取当前受者历史病历
    patientSwitch(e) {
      if (e) {
        this.reginfo.patientID = this.currentDetail.patientID
      } else {
        this.reginfo = {}
      }
      this.pages.pageNum = 1
      this.medicalListBox = []

      this.historyClick('patient')
    },
    importSwitchTwo(e) {
      this.broccoliTwo = e
      this.pages.pageNum = 1
      this.getVisitList('importSwitch')
    },
    prescriptionHistory(item) {
      this.$emit('historyClick', {
        ...item
      })
      Toast.success('导入成功')
      // uni.showToast({
      //   title: '导入成功',
      //   icon: 'none'
      // })
      this.close()
    },
    gearCase(item) {
      if (item.symptomName) {
        const fish = JSON.parse(item.symptomName)
        const fishBox = []
        fish.forEach(element => {
          element ? fishBox.push(element.symptomName) : ''
        })
        return fishBox.toString()
      } else {
        return ''
      }
    },
    close() {
      if (!this.$refs.openTheHistory) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.openTheHistory.close()
      this.showMeta = false
      this.pages.pageNum = 1
    },
    open() {
      this.$refs.openTheHistory.open()
      this.showMeta = true
      this.pages.pageNum = 1
      setTimeout(() => {
        this.activeNumber = 0
        this.isOpenPop = true
      }, 300)
    },
    historyClick(type) {
      let truck = ''
      // 0：中医 1：西医 (用于判定首次医生点击病历类型)
      // 沿用之前锦素的逻辑 medicine为0或1 是针对中医院的
      // console.log('this.medicine', this.medicine)
      // console.log('this.medicine', this.medicine)
      // 中医
      if (this.medicine === 0 && this.isTCM) {
        truck = 2
      } else if (
        // 西医
        this.medicine === 1 &&
        this.isTCM
      ) {
        truck = 1
      } else {
        truck = this.currentDetail.visitRecordType
      }

      Toast('加载中')
      // 如果不是从同一受者病例过来 删除受者id
      if (this.isTCM && type == 'open') {
        delete this.reginfo.patientID
      }
      const params = {
        pageNum: this.pages.pageNum,
        pageSize: this.pages.pageSize,
        hospitalID: this.hospitalID,
        patientID: this.reginfo.patientID,
        doctorName: this.broccoli ? this.doctor.name : '',
        doctorID: this.broccoli ? this.doctor.doctorID : '',
        visitRecordType: truck
      }
      getVisitRecordOnlineListNew(params)
        .then(res => {
          if (res.list.length == 0) {
            Toast.fail('没有更多数据了')
          }

          if (res.code === 0 && res.list) {
            this.pages.pageNum === 1
              ? (this.medicalListBox = res.list)
              : this.medicalListBox.push(...res.list)
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.listError = true
        })
    },
    getVisitList() {
      // uni.showLoading({
      //   title: '加载中'
      // })
      Toast('加载中')
      getVisitRecordList({
        pageNum: this.pages.pageNum,
        pageSize: this.pages.pageSize,
        hospitalID: this.hospitalID,
        patientID: this.reginfo.patientID || this.currentDetail.patientID,
        doctorName: this.broccoliTwo ? this.doctor.name : '',
        doctorID: this.broccoliTwo ? this.doctor.doctorID : ''
      }).then(res => {
        if (res.code === 0) {
          if (res.VisitRecordList.length == 0) {
            Toast.fail('没有更多数据了')
            // uni.showToast({
            //   title: '没有更多数据了',
            //   icon: 'none',
            //   duration: 1500
            // })
          }

          this.pages.pageNum === 1
            ? (this.inquiry = res.VisitRecordList)
            : this.inquiry.push(...res.VisitRecordList)
        }
        this.loading = false
      })
    },
    getMoreList() {
      this.pages.pageNum++
      this.historyClick()
    },
    getMoreListTwo() {
      this.pages.pageNum++
      this.getVisitList()
    },
    getMoreTemplateList() {
      this.pages.pageNum++
      if (!this.tabsList[this.activeNumber].isDone) {
        this.getRecordTemplateLists()
      }
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
::v-deep.tabBlock {
  width: 16rem;
  border-bottom: none;
  background-color: #f9f9f9;
  height: 2.56rem;
  display: flex;
  align-items: center;
  .tab__item {
    flex: 1 !important;
    // width: 5.333333rem;
  }

  .tab__item-title {
    font-size: 0.64rem;
  }

  .tab__line {
    width: 0.853333rem !important;
    height: 0.128rem;
  }
}
</style>
<style lang="scss" scoped>
.medical_history {
  width: 16rem;
  background-color: #fff;
  ::v-deep .tabBlock {
    width: 16rem;
    border-bottom: none;
    background-color: #f9f9f9;
    height: 2.56rem;
    display: flex;
    align-items: center;
    .tab__item {
      flex: 1 !important;
      // width: 5.333333rem;
    }

    .tab__item-title {
      font-size: 0.64rem;
    }

    .tab__line {
      width: 0.853333rem !important;
      height: 0.128rem;
    }
  }
  .test_data {
    display: flex;
    flex-direction: column;
    height: 16rem;
    overflow-x: hidden;

    .switch_box {
      flex: 0 0 auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 0.682667rem;
      padding-bottom: 0.682667rem;
      & > div {
        margin: 0 0 0 0.426667rem;
        display: flex;
        align-items: center;
      }
    }
    .list-wrap {
      flex: 1;
      overflow: auto;
    }

    .medicalList {
      border-bottom: 0.021333rem solid #ececec;
      margin: 0.682667rem 0;

      .medicalText {
        display: flex;
        padding: 0 0.682667rem 0.682667rem 0.682667rem;

        .grayText {
          width: 4.053333rem;
          padding-right: 0.213333rem;
          color: #888;
          font-size: 0.64rem;
        }

        .grayRight {
          width: 76%;
        }
      }
      .identification {
        position: relative;
        display: flex;
        align-items: center;

        .identificationHistory {
          position: absolute;
          right: 0;
          top: 0;
          display: flex;
          align-items: center;
          padding-right: 0.682667rem;

          .case_img {
            width: 0.725333rem;
            height: 0.725333rem;
          }

          .case_text {
            padding-left: 0.341333rem;
            color: #0089ff;
            font-size: 0.64rem;
          }
        }
      }
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    height: 18.773333rem;
    .item {
      padding: 0.64rem;
      height: auto;
      box-sizing: border-box;

      border-bottom: 0.021333rem solid #ececec;
      .title {
        font-size: 0.682667rem;
        font-weight: 500;
        color: #222222;
      }
      .row {
        margin-bottom: 0.256rem;
      }
      .last_row {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .toLead {
          width: 0.64rem;
          height: 0.597333rem;
          margin-right: 0.170667rem;
        }
      }
      .subhead,
      .main {
        font-size: 0.597333rem;
        font-weight: 400;
        color: #888888;
      }
      .text {
        font-size: 0.597333rem;
        font-weight: 400;
        color: #222222;
      }
      .lead_text {
        font-size: 0.597333rem;
        font-weight: 400;
        color: #0089ff;
      }
    }

    .list-wrap {
      flex: 1;
      overflow: auto;
    }
  }

  .nav-tabs {
    flex: 0 0 auto;
    border-bottom: 1px #ececec solid;
    ::v-deep .van-tab {
      color: #333;
    }
    ::v-deep .van-tabs__line {
      background: #007aff;
    }
  }
}
</style>
